export const PLP_FILTER_ORDER = [
  'filterColor',
  'filterFinish',
  'mainStyle',
  'filterLightSize',
  'filterNumberOfLights',
  'indoorOutdoor',
];
